<!--
 * @Description: 
 * @Author: 诺
 * @Date: 2021-12-19 17:08:44
 * @LastEditors: dee
 * @LastEditTime: 2022-09-14 14:17:46
-->
<template>
  <div class="model" :style="{ backgroundColor: `${rgbToRgba(bColor, 0.3)}` }" v-if="list.length != 0">
    <div class="modelTitle" :style="{ backgroundColor: bColor, color: textColor }">
      {{ title }}
    </div>
    <div class="modelBg">
      <div class="list">
        <div class="item" v-for="(item, index) in list" :key="index" :style="{ borderColor: rgbToRgba(bColor, 0.2) }">
          <div class="itemImg">
            <img :src="item.img" />
          </div>
          <div class="itemInfo">
            <div class="name">{{ item.name }}</div>
            <div class="info">{{ item.info }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { rgbToRgba } from "./util";

export default {
  props: ["data", "bColor", "title", "textColor"],
  data() {
    return { list: [] };
  },
  created() {},
  methods: {
    rgbToRgba,
  },
  computed: {},
  watch: {
    data: {
      handler(val) {
        console.log(val);
        let num = 1;
        let list = val.map((item) => {
          let info = "";
          if (num == item.rank) {
            info = `助力值排行第${item.rank}名可领取`;
          } else {
            info = `助力值排行第${num}名到${item.rank}名可领取`;
          }
          num = item.rank + 1;
          return {
            ...item,
            info,
          };
        });
        this.list = list;
      },
      deep: true,
    },
  },
};
</script>
<style lang="stylus" scoped>
.model {
  width: 351px;
  margin: 32px auto 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 12px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-sizing: border-box;
  padding:10px;

  .modelTitle {
    position: absolute;
    margin-top: -10px;
    color: white;
    padding: 0 20px;
    line-height: 40px;
    height: 40px;
    text-align: center;
    display: inline-block;
    font-size: 20px;
    font-weight: 600;
    border-radius: 0px 0px 12px 12px;
  }

  .modelBg {
    width: 100%;
    background-color: rgba(255, 255, 255, 0.9);
    border-radius: 7px;

    .list {
      margin: 46px 15px 13px;

      .item {
        display: flex;
        align-items: center;
        padding: 6px 0;
        border-bottom: 0.5px solid rgba(239, 19, 80, 0.2);

        .itemImg {
          width: 72px;
          height: 72px;
          background-color: #F0F0F0;
          border-radius: 4px;
          overflow:hidden;

          img {
            width: 72px;
            height: 72px;
            object-fit: contain;
          }
        }

        .itemInfo {
          flex: 1;
          margin-left: 16px;
          word-break: break-all;
          .name {
            font-weight: 500;
            font-size: 16px;
            line-height: 24px;
            color: #000000;
          }

          .info {
            font-size: 12px;
            line-height: 16px;
            color: #595959;
          }
        }
      }

      .item:last-child {
        border-bottom: none;
      }
    }
  }
}
</style>
